<template>
  <div class="submit_success">
    <customer-service :position="0"></customer-service>
    <div class="header">
      <div class="title">
        <img class="icon_right" src="../assets/images/icon_right_home.png" alt="" />
        <span class="success">提交成功！</span>
        <!-- <span>关注公众号获取审核结果</span> -->
      </div>
      <p class="tip">
        请密切关注短信通知 获取审核结果，我们将在3-5个工作日内完成审核，请留意短信通知
      </p>
      <!-- <p class="tip">请留意短信通知</p> -->
    </div>
    <!--    <official-account :qrcodeSrc="wxQrcode" :pageuid="pageuid" class="officialAccount"/>-->
    <div class="footer">
      <div class="backHome" @click="backHome">返回活动首页</div>
    </div>
  </div>
</template>
<script>
// import officialAccount from '../components/officialAccount'
import customerService from '../components/customerService'
export default {
  name: 'submitSuccess',
  components: {
    // officialAccount,
    customerService
  },
  data() {
    return {
      pageuid: 'activitiesPage4',
      wxQrcode: ''
    }
  },
  mounted() {
    this.wxQrcode = localStorage.getItem('wxQrcode')
    this.$xesLogger.loadMsg({
      pageuid: this.pageuid
    })
  },
  methods: {
    backHome() {
      this.$router.replace({
        path: '/'
      })
    }
  }
}
</script>
<style lang="less">
.submit_success {
  .officialAccount {
    margin-top: 97/2px;
  }

  .header {
    padding: 60/2px 75/2px 50/2px;
    font-family: PingFang SC Medium, PingFang SC Medium-Medium;
    background: #fef0dc;

    .title {
      margin-bottom: 32/2px;
      font-size: 0;
      font-weight: 500;
      text-align: center;
      color: #333;

      .icon_right {
        width: 43/2px;
        height: 43/2px;
        margin-right: 19/2px;
        vertical-align: -3px;
      }

      .success {
        font-size: 36/2px;
        color: #e52c30;
      }
    }

    .tip {
      font-size: 26/2px;
      font-weight: 400;
      color: #666;
    }
  }

  .footer {
    position: fixed;
    bottom: 23/2px;
    width: 100%;
    text-align: center;

    .backHome {
      font-size: 26/2px;
      font-weight: 500;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      line-height: 98/2px;
      color: #666;
      text-decoration: underline;
    }

    .share {
      width: 615/2px;
      height: 80/2px;
      margin: auto;
      font-size: 30/2px;
      font-weight: 400;
      font-family: FZLanTingHeiS-DB1-GBK Regular, FZLanTingHeiS-DB1-GBK Regular-Regular;
      line-height: 80/2px;
      text-align: center;
      color: #fff;
      background: #e52c30;
      border-radius: 44/2px;
    }
  }
}
</style>
